export default __webpack_public_path__ + "static/media/aksesoris tanaman.3d4f1ab3.png";